import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getErrorCode } from './errorCodes';
import ErrorIcon from './ErrorIcon';
import styles from './styles.module.scss';
import layoutStyles from '../Layout/styles.module.scss';

const ErrorScreen = ({ errorType, tenant = 'default' }) => {
  const { t, i18n } = useTranslation();
  const [ready, setReady] = useState(false);
  const isMobile = window.innerWidth <= 800;
  const code = getErrorCode(errorType, tenant);

  useEffect(() => {
    const loadTranslations = async () => {
      const lang = i18n.language || 'en';
      if (!i18n.hasResourceBundle(lang, 'translation')) {
        try {
          const version = process.env.REACT_APP_BUILD_TIME || Date.now();
          const response = await fetch(
            `./assets/${tenant}/translation/${lang}/translation.json?v=${version}`
          );
          if (response.ok) {
            const translations = await response.json();
            i18n.addResourceBundle(lang, 'translation', translations, true, true);
          }
        } catch (err) {
          console.warn('Could not load translations for ErrorScreen');
        }
      }
      setReady(true);
    };
    loadTranslations();
  }, [tenant, i18n]);

  if (!ready) return null;

  return (
    <>
      <div className={layoutStyles.header}>
        <img
          alt="logo"
          className={layoutStyles.logo}
          src={`/assets/${tenant}/logo.svg`}
        />
      </div>
      <div className={styles.main}>
        <ErrorIcon className={isMobile ? styles.mobileImage : styles.image} />
        <p className={styles.title}>{t(`codeErrors.${code}.title`)}</p>
        <p className={styles.subtitle}>{t(`codeErrors.${code}.message`)}</p>
        <p className={styles.code}>{t('general.reference', { code })}</p>
      </div>
    </>
  );
};

export default ErrorScreen;
